import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormControl, FormGroup, FormControl, ValidationErrors } from '@angular/forms';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';
import { OrdersService } from '../../services/orders.service';
import { CardLists, Card } from '../../classes/orders';
import { Router, ActivatedRoute } from '@angular/router';
import { Ng2CompleterModule } from 'ng2-completer';
import { Location } from '@angular/common'
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { PrintService } from '../../services/print.service';
import { take } from 'rxjs/operators';

@Component({
	selector: 'app-order-inquiry',
	templateUrl: './order-inquiry.component.html',
	styleUrls: ['./order-inquiry.component.scss']
})

export class OrderInquiryComponent implements OnInit, AfterViewInit {
	@Input() name: string;
	@ViewChild('orderView') orderStatusViewRef: ElementRef;
	@ViewChild('invoiceDetails') invoiceDetailsRef: ElementRef;
	@ViewChild('orderDetails') orderDetailsRef: ElementRef;

	@ViewChild('resultTable') resultTable: ElementRef;

	itemSearchRef = new FormControl('');
	orderSearchRef = new FormControl('');
	orderSearchTypeRef = new FormControl('B');
	filterresults: any = [];
	filteredItems: any = [];
	orderData: CardLists;
	customerData: any = [];
	openOrderData: any = [];
	orders: any = [];
	orderSearch: any = [];
	orderResults: any = false;
	ordersFound: any = [];
	showOrderDetails = false;
	showInvoiceDetails = false;
	color: any = 'blue';
	config: any = [];
	pickinglink: any = '';
	invoicelink: any = '';
	invoicelink2: any = '';
	orderdetails: any = false;
	user: any = false;
	sending = false;
	searchsub: any = false;
	displaydetails: any = false;
	creditlink: any = '';
	creditpickinglink: any = '';
	trackOrder = (_: number, item: any) => item?.orderno ?? _;
	customerNumberRef = new FormControl('');
	// Default to today - 30 days

	startDateRef = new FormControl < Date | null > (new Date(Date.now() - 30 * 24 * 60 * 60 * 1000));
	endDateRef = new FormControl < Date | null > (new Date());



	constructor(private printService: PrintService, private globalsService: GlobalsService, private globalSearchService: GlobalSearchService, public router: Router, private route: ActivatedRoute, private ordersService: OrdersService, private location: Location, private modalService: NgbModal) {

		this.color = this.globalSearchService.getColor();
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
		});
		this.globalSearchService.mesagesallowed.next(false);

		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
			this.globalSearchService.user.subscribe(u => {
				this.user = u
			})
		});


		this.pickinglink = this.config.apiServer.baseUrl + this.config.apiServer.pickingLink;
		this.invoicelink = this.config.apiServer.baseUrl + this.config.apiServer.pickingInvoice;
		this.invoicelink2 = this.config.apiServer.baseUrl + this.config.apiServer.invoiceLink;

		this.creditlink = this.config.apiServer.baseUrl + this.config.apiServer.creditLink;
		this.creditpickinglink = this.config.apiServer.baseUrl + this.config.apiServer.creditPickingLink;
	}

	ngOnInit(): void {}

	ngAfterViewInit(): void {
		this.route.queryParams.pipe(take(1)).subscribe(params => {
			const orderno = params['orderno'];
			if (orderno && this.orderDetailsRef) {
				this.ordersService.getOrder(orderno).subscribe(order => {
					this.orderdetails = order;
					this.showOrderDetails = true;
					this.showModal(this.orderDetailsRef, 'orderDetails', order);
					this.router.navigate([], { relativeTo: this.route, queryParams: {}, queryParamsHandling: '' });
				});
			}
		});
	}

	viewCustomer(debtorno: string) {
		this.router.navigate(['/customers/view/' + debtorno]);
	}

	viewInvoice(orderno: any) {
		this.ordersService.getInvoicedOrder(orderno).subscribe((order: any) => {
			this.orderdetails = order
			this.modalService.open(this.orderStatusViewRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {});
		});
	}

	viewOrder(orderno: any) {
		this.showOrderDetails = true;
		this.ordersService.getOrder(orderno).subscribe(order => {
			this.orderdetails = order;
			this.showModal(this.orderDetailsRef, 'orderDetails', order);
		});
	}

	openDocument(transaction: any, display: string) {
		this.showInvoiceDetails = true;
		const fetchDetails = transaction.type === '11' ? this.globalsService.getCreditNote(transaction.id, display) : this.globalsService.getInvoice(transaction.id, display);
		fetchDetails.subscribe(result => {
			this.showModal(this.invoiceDetailsRef, 'invoiceDetails', result);
		});
	}

	showModal(ref: ElementRef, modalType: string, data: any) {
		if (modalType === 'orderDetails') {
			this.orderdetails = data;
		} else if (modalType === 'invoiceDetails') {
			this.displaydetails = data;
		}
		this.modalService.open(ref, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then(() => {
			this.resetModalState(modalType);
		}, () => {
			this.resetModalState(modalType);
		});
	}


	clearForm() {

		//	this.customersearch.setValue('')
	}
	resetModalState(modalType: string) {
		if (modalType === 'orderDetails') {
			this.showOrderDetails = false;
			this.orderdetails = null;
		} else if (modalType === 'invoiceDetails') {
			this.showInvoiceDetails = false;
			this.displaydetails = null;
		}
	}

	public searchOrders() {
		// simple date -> 'YYYY-MM-DD' (keeps backend happy without extra deps)
		const fmt = (d: Date | null) =>
			d ? new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())).toISOString().slice(0, 10) : null;

		// guard: invalid range (optional – silently ignore if end < start)
		const start = this.startDateRef.value;
		const end = this.endDateRef.value;
		const hasBadRange = start && end && end < start;

		const payload: any = {
			keywords: this.orderSearchRef.value,
			orderType: this.orderSearchTypeRef.value,
			issalesman: this.user.user.issalesman,
			salesman: this.user.user.salesman,
			customerNumber: (this.customerNumberRef.value || '').toString().trim() || null,
			dateStart: hasBadRange ? null : fmt(start),
			dateEnd: hasBadRange ? null : fmt(end),
		};

		this.sending = true;
		if (this.searchsub) {
			this.searchsub.unsubscribe();
		}

		this.searchsub = this.ordersService.getOrderInqSearch(payload).subscribe(r => {
			this.sending = false;
			this.orderResults = r;
		});
	}

	public onInput(event: any, keys = 'orderno') {

		// this pushes the input value into the service's Observable.

		this.globalSearchService.searchTerm.next(event.target.value);
		const term = event.target.value;
		const allresults = [];
		if (this.openOrderData) {
			this.setFilteredLists(term);
			this.globalSearchService.itemSearch.next(this.ordersFound);
		}
	}

	filterOrders(orders) {

		const allresults = [];

		if (this.openOrderData && this.orderSearch) {
			const openorders = this.filterItem(this.openOrderData, '-', 'ORDER_NUMBER');
			if (openorders) {
				openorders.forEach(function(value) {
					if (orders.includes(value.ORDER_NUMBER)) {

						allresults.push({ content: 'Open Order', details: value, link: '/orders/lookup/' + value.ORDER_NUMBER })
					}
				});


			}
		}

		this.setFiltered(allresults)

	}

	setFilteredLists(term) {

		const allresults = [];
		const ordersFound = [];
		if (this.openOrderData) {
			const openorders = this.filterItem(this.openOrderData, term, 'ADDRESS_1,CUST_NAME,ORDER_NUMBER,CUST_ORDER_NO_,DATE_ORDERED,DATE_WANTED,CUST_NUMBER,ITEM_NUMBER');
			if (openorders) {
				openorders.forEach(function(value) {
					allresults.push({ content: 'Open Order', details: value, link: '/orders/lookup/' + value.ORDER_NUMBER })
					ordersFound.push(value.ORDER_NUMBER)
				});
			}
		}

		this.ordersFound = ordersFound;


		this.setFiltered(allresults)

	}

	getValueByType(values: any, code: any): number {
		// Always return a number for safe | currency usage
		if (values == null) {return 0;}

		const normalizeCode = (x: any) => (x == null ? '' : String(x).trim().toLowerCase());

		// Extract a numeric from various shapes: raw number, string, or {text/value/amount/...}
		const toNumber = (v: any): number => {
			if (typeof v === 'number' && isFinite(v)) {return v;}
			if (typeof v === 'string') {
				// Strip currency symbols and thousands separators; keep digits, minus, and dot
				const cleaned = v.replace(/[^0-9.\-]/g, '');
				const n = parseFloat(cleaned);
				return isFinite(n) ? n : 0;
			}
			if (v && typeof v === 'object') {
				// Common keys we see in your payloads
				const cand = v.text ?? v.value ?? v.amount ?? v.total ?? v.sub_total ?? v.tax;
				return toNumber(cand);
			}
			return 0;
		};

		// Array of { code, text } or similar
		if (Array.isArray(values)) {
			const want = normalizeCode(code);
			const match = values.find((r: any) => normalizeCode(r?.code) === want);
			return match ? toNumber(match) : 0;
		}

		// Object map support: { tax: '12.34', total: 123.45, ... } or { tax: {text:'$12.34'} }
		if (typeof values === 'object') {
			const direct = (values as any)[code];
			return direct != null ? toNumber(direct) : 0;
		}

		// Fallback
		return 0;
	}



	safeDate(val: any): string | null {
		// guard MySQL zero dates and empty values
		if (!val || val === '0000-00-00' || val === '0000-00-00 00:00:00') {return null;}
		return val;
	}

	safeNum(v: any): number {
		const n = typeof v === 'number' ? v : parseFloat((v ?? '').toString().replace(/[^0-9.\-]/g, ''));
		return isFinite(n) ? n : 0;
	}

	safeInt(v: any): number {
		const n = typeof v === 'number' ? v : parseInt((v ?? '').toString(), 10);
		return isFinite(n) ? n : 0;
	}

	/**
	 * Handle dispatch being {} or [] (sometimes empty array).
	 * Returns the requested field or null.
	 */
	dispatchField(dispatch: any, field: string): any | null {
		if (!dispatch) {return null;}
		if (Array.isArray(dispatch)) {
			return dispatch.length ? (dispatch[0]?.[field] ?? null) : null;
			// If you eventually return multiple dispatch rows, adjust this logic.
		}
		if (typeof dispatch === 'object') {
			return dispatch[field] ?? null;
		}
		return null;
	}

	getFiltered() {
		return this.filteredItems;
	}

	setFiltered(results) {
		this.filteredItems = results;
	}

	assignCopy(input) {
		this.filteredItems = Object.assign([], input);
	}

	filterItem(input, term, keys) {
		if (!term) {
			this.assignCopy(input);
		}
		const result = Object.assign([], input).filter((item) => keys.split(',').some(key => item.hasOwnProperty(key) && new RegExp(term, 'gi').test(item[key])));
		return result
	}

	getDiscountTotal(item: any) {
		const discounted = this.financial(parseFloat(item.unitprice) * (parseFloat(item.discountpercent) / 100));
		const discountprice = parseFloat(item.unitprice) - discounted;
		const total = item.quantity * discountprice;

		return total;
	}

	exportPdf() {
		const now = new Date();
		const filename = 'ORDER_INQUIRY_';
		const element = this.resultTable.nativeElement;

		const cloned = element.cloneNode(true) as HTMLElement;
		this.applyInlineStyles(cloned);

		const html = cloned.outerHTML;
		const encoded = this.globalSearchService.base64encode(html);

		const data = {
			content: encoded,
			filename: filename,
			title: 'Order Inquiry Created',
			subtitle: `Created @ ${now.toLocaleString()}`
		};

		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, filename);
		});
	}

	private exportXls(): void {
		const now = new Date();
		const filename = 'ORDER_INQUIRY_' + now.toISOString().slice(0, 10);
		const container = this.resultTable.nativeElement as HTMLElement;

		// Each order card → create flattened rows with header + item data
		const cards = container.querySelectorAll('.order-card') as NodeListOf < HTMLElement > ;
		const wrapper = document.createElement('div');

		// Create a single flattened table for all orders and items
		const flattenedTable = document.createElement('table');
		flattenedTable.style.borderCollapse = 'collapse';
		flattenedTable.style.width = '100%';
		flattenedTable.style.fontFamily = 'Arial, Helvetica, sans-serif';
		flattenedTable.style.fontSize = '11px';

		// Create header row with all columns
		const headerRow = document.createElement('tr');
		const headerColumns = [
			'Order #', 'Status', 'Created', 'Updated', 'Customer', 'PO / Ref', 'Deliver To', 'Dispatch',
			'Delivered', 'Entered By', 'Edited By', 'Item', 'Description', 'QOH', 'Ordered', 'Invoiced',
			'Outstanding', 'Price'
		];

		// Add discount column only if config.discounts is enabled
		if (this.config?.discounts) {
			headerColumns.push('Discount');
		}

		headerColumns.forEach(column => {
			const th = document.createElement('th');
			th.textContent = column;
			th.style.border = '1px solid #d0d7de';
			th.style.padding = '8px';
			th.style.textAlign = 'left';
			th.style.background = '#eef2f7';
			th.style.fontWeight = '600';
			th.style.whiteSpace = 'nowrap';
			th.style.fontSize = '11px';
			headerRow.appendChild(th);
		});
		flattenedTable.appendChild(headerRow);

		cards.forEach((card) => {
			// 1) Collect header fields
			const $ = < T extends Element = HTMLElement > (sel: string, root: Element | Document = card) =>
				(root.querySelector(sel) as T | null);

			const text = (el: Element | null) => (el && (el as HTMLElement).textContent?.trim()) || '—';
			const valFromMeta = (labelStartsWith: string) => {
				const meta = $('.order-header-meta');
				if (!meta) {return '—';}
				const divs = meta.querySelectorAll('div') as NodeListOf < HTMLElement > ;
				for (const d of Array.from(divs)) {
					const label = d.querySelector('span')?.textContent?.trim() || '';
					if (label.toLowerCase().startsWith(labelStartsWith.toLowerCase())) {
						return d.querySelector('strong')?.textContent?.trim() || '—';
					}
				}
				return '—';
			};

			// Extract header information
			const orderNo = text($('.order-header-main .order-number'));
			const status = text($('.order-header-main .status-badge'));
			const created = valFromMeta('created');
			const updated = valFromMeta('updated');
			const customer = valFromMeta('customer');
			const poRef = valFromMeta('po');
			const deliver = valFromMeta('deliver to');
			const dispatch = valFromMeta('dispatch');
			const delivered = valFromMeta('delivered');
			const entered = valFromMeta('entered by');
			const edited = valFromMeta('edited by');

			// 2) Get items table and create rows for each item
			const itemsTable = card.querySelector('table') as HTMLTableElement | null;
			if (!itemsTable) {
				// If no items, create a single row with header info only
				const emptyItemData = ['—', '—', '—', '—', '—', '—', '—', '—'];
				if (this.config?.discounts) {
					emptyItemData.push('—');
				}
				const emptyRow = this.createFlattenedRow(
					[orderNo, status, created, updated, customer, poRef, deliver, dispatch, delivered, entered, edited],
					emptyItemData
				);
				flattenedTable.appendChild(emptyRow);
				return;
			}

			// 3) Process each item row
			const itemRows = itemsTable.querySelectorAll('tbody tr');
			itemRows.forEach((itemRow) => {
				const cells = itemRow.querySelectorAll('td');
				// Remove the last column (Total) from the item data
				const allItemData = Array.from(cells).map(cell => cell.textContent?.trim() || '—');
				const itemData = allItemData.slice(0, -1); // Remove the last column (Total)

				// Create flattened row with header + item data
				const flattenedRow = this.createFlattenedRow(
					[orderNo, status, created, updated, customer, poRef, deliver, dispatch, delivered, entered, edited],
					itemData
				);
				flattenedTable.appendChild(flattenedRow);
			});

			// 4) No totals row needed - just header and items
		});

		wrapper.appendChild(flattenedTable);

		// Encode and send
		const html = wrapper.innerHTML;
		const encoded = this.globalSearchService.base64encode(html);
		const data = {
			content: encoded,
			filename: filename,
			title: 'Order Inquiry Export',
			subtitle: `Created @ ${now.toLocaleString()}`
		};

		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, filename);
		});
	}

	// Helper method to create a flattened row with header + item data
	private createFlattenedRow(headerData: string[], itemData: string[]): HTMLTableRowElement {
		const row = document.createElement('tr');

		// Combine header and item data
		const allData = [...headerData, ...itemData];

		allData.forEach((value, index) => {
			const cell = document.createElement('td');
			cell.textContent = value;
			cell.style.border = '1px solid #e5e7eb';
			cell.style.padding = '8px';
			cell.style.verticalAlign = 'top';
			cell.style.fontSize = '11px';

			// Apply appropriate formatting based on data type
			if (index < headerData.length) {
				// Header columns
				if (index === 0) {cell.setAttribute('data-type', 'order_number');} // Order #
				else if (index === 1) {cell.setAttribute('data-type', 'status');} // Status
				else if (index === 2 || index === 3 || index === 8) {cell.setAttribute('data-type', 'date');} // Dates
				else if (index === 4) {cell.setAttribute('data-type', 'customer');} // Customer
				else if (index === 5) {cell.setAttribute('data-type', 'po_reference');} // PO Ref
				else if (index === 6) {cell.setAttribute('data-type', 'delivery_address');} // Deliver To
				else if (index === 7) {cell.setAttribute('data-type', 'dispatch_info');} // Dispatch
				else {cell.setAttribute('data-type', 'user');} // Users
			} else {
				// Item columns
				const itemIndex = index - headerData.length;
				if (itemIndex === 0) {
					cell.setAttribute('data-type', 'item_code');
					cell.style.fontFamily = 'Consolas, "Liberation Mono", Menlo, Monaco, monospace';
					cell.style.whiteSpace = 'nowrap';
				} else if (itemIndex === 1) {
					cell.setAttribute('data-type', 'description');
				} else if (itemIndex >= 2 && itemIndex <= 5) {
					cell.setAttribute('data-type', 'quantity');
					cell.style.textAlign = 'right';
					cell.style.fontVariantNumeric = 'tabular-nums';
				} else if (itemIndex === 6) {
					cell.setAttribute('data-type', 'currency');
					cell.style.textAlign = 'right';
					cell.style.fontVariantNumeric = 'tabular-nums';
				} else if (itemIndex === 7) {
					cell.setAttribute('data-type', 'percentage');
					cell.style.textAlign = 'right';
					cell.style.fontVariantNumeric = 'tabular-nums';
				}
			}

			row.appendChild(cell);
		});

		return row;
	}

	// Helper method to create a summary table for Excel filtering
	private createSummaryTable(cards: NodeListOf < HTMLElement > ): HTMLTableElement | null {
		if (cards.length === 0) {return null;}

		const summaryTable = document.createElement('table');
		summaryTable.style.borderCollapse = 'collapse';
		summaryTable.style.width = '100%';
		summaryTable.style.fontFamily = 'Arial, Helvetica, sans-serif';
		summaryTable.style.fontSize = '11px';
		summaryTable.style.marginTop = '20px';
		summaryTable.style.pageBreakBefore = 'always';

		// Add summary header
		const summaryHeader = document.createElement('tr');
		const headerCell = document.createElement('th');
		headerCell.textContent = 'ORDER INQUIRY SUMMARY';
		headerCell.colSpan = 8;
		headerCell.style.textAlign = 'center';
		headerCell.style.background = '#2c3e50';
		headerCell.style.color = 'white';
		headerCell.style.padding = '12px';
		headerCell.style.fontSize = '14px';
		headerCell.style.fontWeight = 'bold';
		headerCell.style.border = '1px solid #34495e';
		summaryHeader.appendChild(headerCell);
		summaryTable.appendChild(summaryHeader);

		// Add summary stats
		const statsRow = document.createElement('tr');
		const statsCell = document.createElement('td');
		statsCell.colSpan = 8;
		statsCell.style.padding = '8px';
		statsCell.style.border = '1px solid #d0d7de';
		statsCell.style.background = '#f8f9fa';
		statsCell.innerHTML = `
		<strong>Export Summary:</strong><br>
		• Total Orders: ${cards.length}<br>
		• Export Date: ${new Date().toLocaleDateString()}<br>
		• Export Time: ${new Date().toLocaleTimeString()}<br>
		• Each order includes header information and item details for Excel filtering
	  `;
		statsRow.appendChild(statsCell);
		summaryTable.appendChild(statsRow);

		return summaryTable;
	}

	private exportWithInlineStyles(format: 'pdf' | 'xls'): void {
		const now = new Date();
		const filename = 'ORDER_INQUIRY_';
		const element = this.resultTable.nativeElement;

		// Deep clone node
		const cloned = element.cloneNode(true) as HTMLElement;

		// Inline all computed styles
		this.applyInlineStyles(cloned);

		// Encode HTML
		const html = cloned.outerHTML;
		const encoded = this.globalSearchService.base64encode(html);

		// Build export payload
		const data = {
			content: encoded,
			filename: filename,
			title: 'Order Inquiry Created',
			subtitle: `Created @ ${now.toLocaleString()}`
		};

		// Send to print service
		const serviceCall = format === 'pdf' ? this.printService.pdf(data) : this.printService.xls(data);
		serviceCall.subscribe((result: any) => {
			if (format === 'pdf') {
				this.globalSearchService.downloadPdf(result.content, filename);
			} else {
				this.globalSearchService.downloadXls(result.content, filename);
			}
		});
	}

	private applyInlineStyles(element: HTMLElement): void {
		const treeWalker = document.createTreeWalker(element, NodeFilter.SHOW_ELEMENT);

		while (treeWalker.nextNode()) {
			const node = treeWalker.currentNode as HTMLElement;
			const computed = window.getComputedStyle(node);

			let inlineStyle = '';

			for (let i = 0; i < computed.length; i++) {
				const propName = computed.item(i);
				const propValue = computed.getPropertyValue(propName);
				inlineStyle += `${propName}: ${propValue}; `;
			}

			node.setAttribute('style', inlineStyle.trim());
		}
	}

	statusClass(id: any): string {
		const n = parseInt(id, 10);
		if (n === 80) { return 'status-credit-hold'; }
		if (n === 53) { return 'status-preauth-authorized'; }
		if (n === 52) { return 'status-preauth-decline'; }
		if (n >= 90) {return 'status-cancelled';}
		if (n > 29 && n < 51) {return 'status-invoiced';}
		if (n <= 29) {return 'status-open';}
		return 'status-default';
	}

	financial(num: number): number {

		const rounded = Math.round((num + Number.EPSILON) * 100) / 100; // Rounding to 2 decimal places again
		return parseFloat(rounded.toFixed(2));
	}

	navTo(link) {

		this.router.navigate([link]);
	}
	back(): void {
		this.location.back()
	}

}